import React, { Component, Fragment } from 'react'
import Headers from '../components/Headers/'
import Footer from '../components/Footer/'

function withHeaderFooter(WrappedComponent, headerSize, color) {
  return class extends Component {
    render() {
      return (
        <Fragment>
          <Headers
            branchName={this.props.branchName}
            branch={this.props.branch}
            logo={headerSize}
            orderId={this.props.orderId}
            deliveryId={this.props.deliveryId}
            portalOrderId={this.props.portalOrderId}
            suspended={this.props.suspended}
            color={color}
          />
          <WrappedComponent {...this.props} />
          <Footer />
        </Fragment>
      )
    }
  }
}

export default withHeaderFooter



// WEBPACK FOOTER //
// ./src/wrapper/withHeaderFooter.js